import { render, staticRenderFns } from "./FavouriteManager.vue?vue&type=template&id=4acb65cc&scoped=true&"
import script from "./FavouriteManager.vue?vue&type=script&lang=ts&"
export * from "./FavouriteManager.vue?vue&type=script&lang=ts&"
import style0 from "./FavouriteManager.vue?vue&type=style&index=0&id=4acb65cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acb65cc",
  null
  
)

export default component.exports
import {QBtn,QIcon,QBadge,QDialog,QCard,QCardSection,QToolbar,QSpace,QToggle,QTooltip,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QIcon,QBadge,QDialog,QCard,QCardSection,QToolbar,QSpace,QToggle,QTooltip})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
